export default "__VITE_ASSET__CzsH6KyB__"